const { COUNTRIES_WITH_DELIVERY_DEALER } = require("../../constants");

const getShouldDeliveryDealerBeIncluded = country =>
  COUNTRIES_WITH_DELIVERY_DEALER.includes(country);

module.exports = { getShouldDeliveryDealerBeIncluded };
